import React from 'react';

type Props = {
  label: string;
  value: string;
  onChange: (pin: string) => void;
  autoFocus?: boolean;
};

/** 6-digit wallet PIN input (masked, numeric only). */
const PinField: React.FC<Props> = ({ label, value, onChange, autoFocus }) => {
  return (
    <label className="block space-y-1">
      <span className="text-sm font-medium medium-emphasis-text">{label}</span>
      <input
        type="password"
        inputMode="numeric"
        autoComplete="one-time-code"
        autoFocus={autoFocus}
        maxLength={6}
        value={value}
        onChange={(e) =>
          onChange(e.target.value.replace(/\D/g, '').slice(0, 6))
        }
        placeholder="••••••"
        className="w-full text-center tracking-[0.5em] font-mono text-lg py-2.5 px-3 rounded-lg border border-border bg-background dark:bg-background-accent high-emphasis-text focus:outline-none focus:ring-2 focus:ring-primary/40"
      />
    </label>
  );
};

export default PinField;
